import styled from 'styled-components';
import { v2Colors, v2FontFamily } from '../../../formInputsV2/styles/tokens';

// The v2 Brokeraggio card reuses the ServiceComponent card pieces
// (ServiceComponent.styles.js, left untouched); only the notice is its own.

export const BrokerageNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid ${v2Colors.warningBorder};
  border-radius: 10px;
  background: ${v2Colors.warningSoft};
  color: ${v2Colors.warningText};
  font-family: ${v2FontFamily};
  font-size: 13px;
  line-height: 1.5;

  svg {
    flex-shrink: 0;
    margin-top: 3px;
    color: ${v2Colors.warning};
  }

  p {
    margin: 0;
  }
`;

// Input and the "spese di emissione" notice share one row, so the notice
// appearing at EUR 20 or more adds no height and the slider below never moves.
export const BrokerageFieldRow = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 10px 12px;

  ${BrokerageNotice} {
    flex: 1 1 280px;
    margin-top: 0;
  }
`;
